export default class BasketStatus {
  static get inProcess () { return 'in_process' }
  static get inOrder () { return 'in_order' }
}
